"use strict";

module.exports = process.env.NODE_ENV === "production" ? require("./mocks") : require("./proptypes");